import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSubSalesManByCode } from "../api/sales_man";

export const useSubSalesValidation = (kdBusiness, redirectPath = "/") => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [subSalesManData, setSubSalesManData] = useState(null);
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const fetchSubSalesMan = async () => {
      if (!kdBusiness) {
        setIsValid(true);
        return;
      }

      setIsLoading(true);

      try {
        const result = await getSubSalesManByCode(kdBusiness);

        if (result.success && result.data) {
          setSubSalesManData(result.data);
          setIsValid(true);
        } else {
          setIsValid(false);
          navigate(redirectPath);
        }
      } catch (error) {
        console.error("Error fetching SubSalesMan:", error);
        setIsValid(false);
        navigate(redirectPath);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubSalesMan();
  }, [kdBusiness, navigate, redirectPath]);

  return {
    isLoading,
    subSalesManData,
    isValid,
  };
};
